import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";
import { ConfigFieldsProps } from "./types";

export function ContainerConfig({
  editedComponent,
  updateConfig,
}: ConfigFieldsProps) {
  const config = editedComponent.config;
  const style = config.style || {};

  const updateStyle = (key: string, value: any) => {
    updateConfig("style", { ...style, [key]: value });
  };

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="containerTitle">Título (opcional)</Label>
        <Input
          id="containerTitle"
          type="text"
          value={config.title || ""}
          onChange={(e) => updateConfig("title", e.target.value)}
          placeholder="Ex: Resumo financeiro"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="containerDirection">Direção dos componentes</Label>
        <Select
          value={config.direction || "vertical"}
          onValueChange={(value) => updateConfig("direction", value)}
        >
          <SelectTrigger id="containerDirection">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="vertical">
              Vertical (empilhados de cima para baixo)
            </SelectItem>
            <SelectItem value="horizontal">
              Horizontal (lado a lado)
            </SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          Os componentes dividem o espaço do container igualmente nessa direção.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-2">
          <Label htmlFor="containerGap">Espaçamento entre itens (px)</Label>
          <Input
            id="containerGap"
            type="number"
            min={0}
            value={config.gap ?? 16}
            onChange={(e) => updateConfig("gap", Number(e.target.value))}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="containerPadding">Padding interno (px)</Label>
          <Input
            id="containerPadding"
            type="number"
            min={0}
            value={style.padding ?? 16}
            onChange={(e) => updateStyle("padding", Number(e.target.value))}
          />
        </div>
      </div>

      <div className="p-4 bg-accent border border-primary/20 rounded-md">
        <p className="text-sm">
          <strong>💡 Dica:</strong> O container usa automaticamente as cores do
          tema atual. Arraste componentes da paleta da esquerda para dentro do
          container no canvas; cada um pode ser editado ou removido passando o
          mouse sobre ele.
        </p>
      </div>
    </>
  );
}
